import { Box, ProgressCircle, type ProgressTrackProps } from '@chakra-ui/react';
import type React from 'react';
import type { FC } from 'react';

export interface FaceliftProgressProps {
	value: number | null;
	size?: 'sm' | 'md' | 'lg';
}

export interface ProgressTrackProps2 extends ProgressTrackProps {
	children?: React.ReactNode;
}

const CustomProgress = {
	Root: (props: React.ComponentProps<typeof ProgressCircle.Root>) => (
		<ProgressCircle.Root {...props} />
	),
	Circle: (props: ProgressTrackProps2) => (
		<ProgressCircle.Circle {...props} />
	),
	Track: (props: ProgressTrackProps2) => <ProgressCircle.Track {...props} />,
	Range: (props: React.ComponentProps<typeof ProgressCircle.Range>) => (
		<Box as={ProgressCircle.Range} bg="brand.solidGradient" {...props} />
	),
};

const FaceliftCircularProgress: FC<FaceliftProgressProps> = ({
	value,
	size = 'sm',
	...rest
}) => {
	return (
		<CustomProgress.Root
			width="100%"
			value={value}
			size={size}
			colorPalette="brand"
			{...rest}
		>
			<CustomProgress.Circle>
				<CustomProgress.Track />
				<CustomProgress.Range />
			</CustomProgress.Circle>
		</CustomProgress.Root>
	);
};

export default FaceliftCircularProgress;
